import { createApp } from 'vue'
import App from './App.vue'
import { createStore } from "vuex";
import "bootstrap/dist/css/bootstrap.min.css"

import router  from './routes/index.js'

const store = new createStore({
    state:()=>( {        
            idCliente:0,
            optante:null,
                  
    }),  })
createApp(App).use(router).use(store).mount('#app')